var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-item nav-link",class:_vm.active,attrs:{"data-toggle":"tab","href":"#" + _vm.item.href}},[_vm._v("\n  "+_vm._s(_vm.item.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }